/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PrerequisiteType = {
    EVENT: 'EVENT',
    QUEST_COMPLETION: 'QUEST_COMPLETION',
    QUEST_RESOLVED: 'QUEST_RESOLVED',
    QUEST_EXPIRED: 'QUEST_EXPIRED',
    QUEST_MEMBERSHIP: 'QUEST_MEMBERSHIP',
    TOKEN_BALANCE: 'TOKEN_BALANCE',
    LEVEL: 'LEVEL',
    NFT: 'NFT',
    GUILD_MEMBERSHIP: 'GUILD_MEMBERSHIP',
    REFERRAL: 'REFERRAL',
    MENU_ORDER: 'MENU_ORDER',
    REDEEM_LOOTBOX: 'REDEEM_LOOTBOX',
    CHALLENGE_MEMBERSHIP: 'CHALLENGE_MEMBERSHIP',
    ACTIVATION_COMPLETION: 'ACTIVATION_COMPLETION',
    STREAK_THRESHOLD: 'STREAK_THRESHOLD',
    SUBSCRIPTION_TIER: 'SUBSCRIPTION_TIER',
    MIN_TRUST_SCORE: 'MIN_TRUST_SCORE',
    MIN_ACCOUNT_AGE_DAYS: 'MIN_ACCOUNT_AGE_DAYS'
} as const;
export type PrerequisiteType = typeof PrerequisiteType[keyof typeof PrerequisiteType];


export function instanceOfPrerequisiteType(value: any): boolean {
    for (const key in PrerequisiteType) {
        if (Object.prototype.hasOwnProperty.call(PrerequisiteType, key)) {
            if (PrerequisiteType[key as keyof typeof PrerequisiteType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrerequisiteTypeFromJSON(json: any): PrerequisiteType {
    return PrerequisiteTypeFromJSONTyped(json, false);
}

export function PrerequisiteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrerequisiteType {
    return json as PrerequisiteType;
}

export function PrerequisiteTypeToJSON(value?: PrerequisiteType | null): any {
    return value as any;
}

export function PrerequisiteTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PrerequisiteType {
    return value as PrerequisiteType;
}

